import React from 'react'
import { Outlet } from 'react-router-dom'
import Navbar from 'components/generales/Navbar'
import FiltrosBalance from 'pages/balance/FiltrosBalance'
import construccion from 'components/generales/under_constructions.png'


const ListadoMetas = () => {
  return (
    <>
      <Outlet />
      <Navbar />
      <div className='lista-preview'>
        <h2>Listado de Metas</h2>
        <p>Metas Registradas</p>
        <br></br>
        <FiltrosBalance />
        <img src={construccion} alt="Sitio en construcción" />
      </div>
    </>
  )
}

export default ListadoMetas